import React, { useEffect, useState, useCallback } from "react";

import logout from "../../api/logout";

import { signOut } from "../../utils/common";

import "./AuthFailedPage.css";

const AuthFailedPage = ({ history }) => {
  const [timeRemaining, setTimeRemaining] = useState(10);
  const handleLogout = useCallback(() => {
    logout().catch(() => {
      // Silently handle errors - will still clear storage
    });
    signOut(history, null);
  }, [history]);

  /**
   * Set countdown timer.
   */
  useEffect(() => {
    if (!timeRemaining) {
      handleLogout();
      return undefined;
    }
    const intervalID = setInterval(() => setTimeRemaining((prev) => prev - 1), 1000);

    return () => clearInterval(intervalID);
  }, [timeRemaining, handleLogout]);

  return (
    <div className="AuthFailedPage">
      <span className="AuthFailedPage__Header">{`Signing out in ${timeRemaining}s`}</span>
      <span className="AuthFailedPage__SubHeader">Authentication failed.</span>
      <button
        type="button"
        onClick={handleLogout}
        className="AuthFailedPage__SignOutButton"
      >
        Sign Out
      </button>
    </div>
  );
};

export default AuthFailedPage;
